import cn from 'classnames';
import styles from './emptyState.module.scss';
import { Text } from '@/ui-components/atoms/Text/Text';

export interface EmptyStateProps {
    headline: string;
    subhead?: string;
    image: React.ReactElement<typeof HTMLImageElement>;
    className?: string;
}

export function EmptyState({ headline, subhead, image, className }: EmptyStateProps): React.JSX.Element {
    return (
        <>
            <div className={cn(className, styles.emptyStateWrapper)}>
                {image}
                <Text tag="p" variant="h6" className={styles.headline}>
                    {headline}
                </Text>
                {subhead && <p className={styles.subhead}>{subhead}</p>}
            </div>
        </>
    );
}
